import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';

import { useAnalytics } from '../../../hooks/dataTracking/useAnalytics';
import { useSettings } from '../../../hooks/use-settings';

export const ThemeModeButton = () => {
  const { settings, saveSettings } = useSettings();
  const { sendButtonClickTrackingEvent } = useAnalytics();

  const handleClick = () => {
    if (settings.theme === 'dark') {
      saveSettings({
        ...settings,
        theme: 'light',
      });
      sendButtonClickTrackingEvent('Switch theme to light mode');
    } else {
      saveSettings({
        ...settings,
        theme: 'dark',
      });
      sendButtonClickTrackingEvent('Switch theme to dark mode');
    }
  };

  return (
    <>
      {settings.theme === 'light' ? (
        <Tooltip title="Dark Mode" placement={'top'}>
          <IconButton color="primary" onClick={handleClick}>
            <DarkModeIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Light Mode" placement={'top'}>
          <IconButton color="primary" onClick={handleClick}>
            <LightModeIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};
